// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#modal-permissions .bloc-button-group {
  max-width: 70%;
  margin: auto;
}
#modal-permissions .bloc-actions {
  margin-top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/components/dialog/dialog-permissions-kanban/dialog-permissions-kanban.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,YAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":["#modal-permissions {\r\n    .bloc-button-group {\r\n        max-width: 70%;\r\n        margin: auto;\r\n    }\r\n\r\n    .bloc-actions {\r\n        margin-top: 25px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
